import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { v4 as uuidv4 } from 'uuid'
import { URL_STORAGE_SUPABASE } from '../../const'

import { useProfessional } from '../../context/ProfessionalContext'
import { useSpecialty } from '../../context/SpecialtiesContext'

import { IconCheck, IconClose, IconSave, IconTrash } from '../icons/Icons'
import Input from '../common/Input'
import Select from '../common/Select'
import ButtonPrimaryForm from '../common/ButtonPrimaryForm'

const ProfessionalsForm = ({ idData }) => {
    const [status, setStatus] = useState(true)
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
    const MySwal = withReactContent(Swal)
    const [formData, setFormData] = useState({
        arbitrator: false,
        adjudicator: false,
        first_name: '',
        last_name: '',
        profession: '',
        birthdate: null,
        validity: '',
        admission: null,
        location_id: '',
        type_of_locations_id: '',
        cessation: null,
        cv: '',
        picture: '',
        osce: false,
        add_list: false,
        status: true,
    })
    const {
        loading,
        locations,
        typeLocations,
        specialtiesCheck,
        getProfessional,
        getLocations,
        getTypeLocations,
        getProfessionalSpecialty,
        createProfessional,
        createProfessionalHasSpecialties,
        updateProfessional,
        deleteProfessionalHasSpecialties,
        uploadFiles,
        deleteFiles,
    } = useProfessional()
    const {
        specialties,
        getSpecialties
    } = useSpecialty()

    useEffect(() => {
        getById(idData)
        getLocations()
        getTypeLocations()
        getSpecialties()
        idData !== null && getProfessionalSpecialty(idData)
    }, [idData])

    useEffect(() => {
        idData !== null && setSelectedCheckboxes(specialtiesCheck)
    }, [specialtiesCheck, idData])

    const getById = async (id) => {
        if (id !== null) {
            const resp = await getProfessional(id)
            setFormData(() => (resp))
            setStatus(resp.status)
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(() => ({
            ...formData,
            [name]: value,
        }));
    }

    const handleInputCheckboxChange = (e) => {
        const { name, value, checked } = e.target;
        if (checked) {
            setFormData(() => ({
                ...formData,
                [name]: value,
            }));
        }
    };

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            setSelectedCheckboxes([...selectedCheckboxes, +value]);
        } else {
            setSelectedCheckboxes(selectedCheckboxes.filter((item) => item !== +value));
        }
    };


    const handleSubmit = async (e) => {
        e.preventDefault()

        if (idData !== null) {
            const resp = await updateProfessional(formData, idData)
            if (selectedCheckboxes.length > 0) {
                await deleteProfessionalHasSpecialties(idData)
                selectedCheckboxes.map(async (item) => {
                    await createProfessionalHasSpecialties([{
                        professionals_id: idData,
                        specialties_id: item
                    }])
                })
                MySwal.fire({
                    title: resp.title,
                    text: resp.msg,
                    icon: resp.icon,
                    customClass: {
                        confirmButton: 'btn-alert-primary',
                        cancelButton: 'btn-alert-danger',
                        title: 'title-alert',
                        htmlContainer: 'text-alert'
                    },
                })
            } else {
                await deleteProfessionalHasSpecialties(idData)
                MySwal.fire({
                    title: resp.title,
                    text: resp.msg,
                    icon: resp.icon,
                    customClass: {
                        confirmButton: 'btn-alert-primary',
                        cancelButton: 'btn-alert-danger',
                        title: 'title-alert',
                        htmlContainer: 'text-alert'
                    },
                })
            }
        } else {
            const resp = await createProfessional(formData)
            if (resp.code === 201 && selectedCheckboxes.length > 0) {
                selectedCheckboxes.map(async (item) => {
                    const r = await createProfessionalHasSpecialties([{
                        professionals_id: resp.last_id,
                        specialties_id: item
                    }])
                    MySwal.fire({
                        title: r.title,
                        text: r.msg,
                        icon: r.icon,
                        customClass: {
                            confirmButton: 'btn-alert-primary',
                            cancelButton: 'btn-alert-danger',
                            title: 'title-alert',
                            htmlContainer: 'text-alert'
                        },
                    })
                })
            } else {
                MySwal.fire({
                    title: resp.title,
                    text: resp.msg,
                    icon: resp.icon,
                    customClass: {
                        confirmButton: 'btn-alert-primary',
                        cancelButton: 'btn-alert-danger',
                        title: 'title-alert',
                        htmlContainer: 'text-alert'
                    },
                })
            }
        }
    }

    const handleFileChange = async (event, path) => {
        const fileData = event.target.files[0];
        const uuid = uuidv4()
        const res = await uploadFiles(fileData, path, uuid)
        if (res.error !== null) {
            MySwal.fire({
                title: res.title,
                text: res.msg,
                icon: res.icon,
                customClass: {
                    confirmButton: 'btn-alert-primary',
                    cancelButton: 'btn-alert-danger',
                    title: 'title-alert',
                    htmlContainer: 'text-alert'
                },
            })
        }
        setFormData(() => ({
            ...formData,
            cv: uuid,
        }));
    };

    const handleDeleteFile = async () => {
        await deleteFiles('cv', formData.cv)
        setFormData(() => ({
            ...formData,
            cv: "",
        }));
    }

    const handleImageChange = async (event, path) => {
        const fileData = event.target.files[0];
        const uuid = uuidv4()
        const res = await uploadFiles(fileData, path, uuid)
        if (res.error !== null) {
            MySwal.fire({
                title: res.title,
                text: res.msg,
                icon: res.icon,
                customClass: {
                    confirmButton: 'btn-alert-primary',
                    cancelButton: 'btn-alert-danger',
                    title: 'title-alert',
                    htmlContainer: 'text-alert'
                },
            })
        }
        setFormData(() => ({
            ...formData,
            picture: uuid,
        }));
    };

    const handleDeleteImage = async () => {
        await deleteFiles('pictures', formData.picture)
        setFormData(() => ({
            ...formData,
            picture: "",
        }));
    }

    const handleStatusChange = () => {
        setStatus(!status)
        setFormData(() => ({
            ...formData,
            status: !status,
        }));
    }

    return (
        <>
            <div className='w-full flex flex-col md:flex-row items-center gap-4'>
                <button
                    className={` border px-3 py-1 rounded-sm transition-colors text-white duration-300 font-light flex items-center gap-1 ${status ? 'bg-primary/90 hover:bg-primary border-primary' : 'bg-secondary/90 hover:bg-secondary border-secondary'}`}
                    onClick={() => handleStatusChange()}
                >
                    {status ? <IconCheck className='w-4 h-4' /> : <IconClose className='w-4 h-4' />}
                    {status ? "Activo" : "Inactivo"}
                </button>
            </div>
            <hr className='my-5' />
            <form onSubmit={handleSubmit}>
                <div className='grid grid-cols-2 gap-4 mt-4 items-end'>
                    <div className='flex items-center gap-4'>
                        <label className='flex gap-1'>
                            <input
                                type="checkbox"
                                name="arbitrator"
                                value={true}
                                checked={formData.arbitrator}
                                onChange={handleInputCheckboxChange}
                            />
                            Árbitro
                        </label>
                        <label className='flex gap-1'>
                            <input
                                type="checkbox"
                                name="adjudicator"
                                value={true}
                                checked={formData.adjudicator}
                                onChange={handleInputCheckboxChange}
                            />
                            Adjudicador
                        </label>
                        <label className='flex gap-1'>
                            <input
                                type="checkbox"
                                name="osce"
                                value={true}
                                checked={formData.osce}
                                onChange={handleInputCheckboxChange}
                            />
                            RNA OSCE
                        </label>
                        <label className='flex gap-1'>
                            <input
                                type="checkbox"
                                name="add_list"
                                value={true}
                                checked={formData.add_list}
                                onChange={handleInputCheckboxChange}
                            />
                            Pertenece lista
                        </label>
                    </div>
                    <div className='flex justify-end'>
                        <label className='w-20 h-20 object-cover border border-gray-300 float-right cursor-pointer overflow-hidden relative'>
                            {
                                loading && <img className='absolute w-20 h-20 top-0 right-0' src='/loading.svg' alt='Loading' />
                            }
                            {
                                formData.picture !== "" && <button
                                    className='absolute right-1'
                                    type='button'
                                    onClick={() => handleDeleteImage()}
                                >
                                    <IconClose className='w-4 h-4' />
                                </button>
                            }
                            <img
                                src={formData.picture !== "" ? URL_STORAGE_SUPABASE + 'pictures/' + formData.picture : 'https://dlclizvwezaxdcvsmuip.supabase.co/storage/v1/object/public/files/pictures/f73fe9b4-cc10-4960-b33f-ec35a31c7471'}
                                alt=''
                                className='w-full' />
                            {
                                formData.picture === "" && <input
                                    type="file"
                                    className='hidden'
                                    name="picture"
                                    onChange={(e) => handleImageChange(e, "pictures")}
                                />
                            }
                        </label>
                    </div>
                </div>
                <div className='grid grid-cols-3 gap-4 mt-4 items-end'>
                    <Input
                        placeholder={'Nombres'}
                        typeInput={"text"}
                        name={"first_name"}
                        className='w-full'
                        required={true}
                        value={formData.first_name}
                        onChange={handleInputChange}
                    />

                    <Input
                        placeholder={'Apellidos'}
                        typeInput={"text"}
                        name={"last_name"}
                        className='w-full'
                        required={true}
                        value={formData.last_name}
                        onChange={handleInputChange}
                    />
                </div>
                <div className='grid grid-cols-2 gap-x-10 gap-y-2 mt-4 items-end'>
                    <Input
                        textLabel={'Profesión:'}
                        typeInput={"text"}
                        name={"profession"}
                        className='w-3/4'
                        value={formData.profession}
                        onChange={handleInputChange}
                    />

                    <Input
                        textLabel={'F. de nacimiento:'}
                        typeInput={"date"}
                        name={"birthdate"}
                        className='w-3/4'
                        value={formData.birthdate || ''}
                        onChange={handleInputChange}
                    />

                    <Input
                        textLabel={'Vigencia:'}
                        typeInput={"text"}
                        name={"validity"}
                        className='w-3/4'
                        value={formData.validity}
                        onChange={handleInputChange}
                    />

                    <Input
                        textLabel={'F. de ingreso:'}
                        typeInput={"date"}
                        name={"admission"}
                        className='w-3/4'

                        value={formData.admission || ''}
                        onChange={handleInputChange}
                    />

                    <Select
                        textLabel={'Ciudad:'}
                        name={"location_id"}
                        className='w-3/4'
                        value={formData.location_id}
                        onChange={handleInputChange}
                        dataOptions={locations}
                        required={true}
                    />

                    <Input
                        textLabel={'F. de cese:'}
                        typeInput={"date"}
                        name={"cessation"}
                        className='w-3/4'
                        value={formData.cessation || ''}
                        onChange={handleInputChange}
                    />

                    <Select
                        textLabel={'Tipo locación:'}
                        name={"type_of_locations_id"}
                        className='w-3/4'
                        value={formData.type_of_locations_id}
                        onChange={handleInputChange}
                        dataOptions={typeLocations}
                        required={true}
                    />
                    {
                        formData.cv !== '' ?
                            <div className='flex items-center justify-between gap-2 w-full border border-gray-300 focus:border-gray-400 rounded-lg pl-4 bg-zinc-100'>
                                <a
                                    href={URL_STORAGE_SUPABASE + `cv/${formData.cv}`}
                                    target='_blank'
                                    rel="noreferrer"
                                    className='text-sm font-light hover:text-primary/90 transition-colors duration-300'>
                                    Ver curriculum vitae
                                </a>
                                <button
                                    type='button'
                                    className='border border-danger bg-danger p-2 rounded-sm hover:bg-danger/80 text-white transition-colors duration-300'
                                    onClick={() => handleDeleteFile()}
                                >
                                    <IconTrash className='w-4 h-4' />
                                </button>
                            </div>
                            :
                            <Input
                                textLabel={'Curriculum:'}
                                typeInput={"file"}
                                name={"cv"}
                                className='w-3/4'
                                onChange={(e) => handleFileChange(e, "cv")}
                            />
                    }
                </div>
                <h4 className='mt-3'>Especialidades:</h4>
                <div className='grid grid-cols-4 gap-x-4 gap-y-2 mt-1 items-start border border-gray-300 rounded-lg p-3 overflow-y-scroll h-[300px] md:h-[150px]'>
                    {
                        specialties.map((item, index) => {
                            return <label key={index} className='flex items-start gap-1 text-xs capitalize'>
                                <input
                                    type="checkbox"
                                    name="specialty"
                                    value={item.id}
                                    checked={selectedCheckboxes.includes(item.id)}
                                    onChange={handleCheckboxChange}
                                />
                                {item.name}
                            </label>
                        })
                    }
                </div>
                <div className="flex justify-between items-center gap-2 mt-6">
                    <div className='flex flex-col gap-2'>
                        <span className='text-red-500 text-xs italic'>* Campos obligatorios</span>
                    </div>
                    <div className='flex gap-2 items-center'>
                        <ButtonPrimaryForm text={'Guardar'} typeBtn={'submit'} >
                            <IconSave className='w-4' />
                        </ButtonPrimaryForm>
                    </div>
                </div>
            </form>
        </>
    )
}

export default ProfessionalsForm